import React from 'react';
import { ColumnCount } from '../../cus-product-list.data';

interface ColumnToggleProps {
    singleColumnViewAriaLabel: string;
    twoColumnViewAriaLabel: string;
    columns: ColumnCount;
    onChange: (columns: ColumnCount) => void;
}

export default function ColumnToggle({ singleColumnViewAriaLabel, twoColumnViewAriaLabel, columns, onChange }: ColumnToggleProps) {
    return (
        <div className='bs-product-list__column-toggle'>
            <button
                type='button'
                className={`bs-product-list__column-toggle__btn${columns === 1 ? ' --active' : ''}`}
                onClick={() => onChange(1)}
                aria-label={singleColumnViewAriaLabel}
                aria-pressed={columns === 1}
            >
                <span className='bs-product-list__column-toggle__btn__icon--single' aria-hidden='true' />
            </button>
            <button
                type='button'
                className={`bs-product-list__column-toggle__btn${columns === 2 ? ' --active' : ''}`}
                onClick={() => onChange(2)}
                aria-label={twoColumnViewAriaLabel}
                aria-pressed={columns === 2}
            >
                <span className='bs-product-list__column-toggle__btn__icon--grid' aria-hidden='true' />
            </button>
        </div>
    );
}
